(function() {
    var listSelectDirective = "listSelect";
    var focusListDirective = "focusList";
    angular
        .module("fleetviewApp")
        .directive(listSelectDirective, ["$timeout",
        function($timeout) {
            return {
                restrict: "A",
                link: function(scope, element, attrs) {
                    if (scope.$last) {
                        $timeout(function() {
                            element.parent().children().first().focus().addClass("selected");
                        }, 1);
                    }
                    element.bind("keydown keypress", function(event) {
                        if (event.which === 13) {
                            scope.$apply(function() {
                                scope.$eval(attrs.listSelectOnEnter);
                            });
                            event.preventDefault();
                        }

                        if (event.which === 38) {//up arrow
                            element.removeClass("selected").siblings().removeClass("selected");
                            if (element.is(element.parent().children().first())) {
                                element.focus().addClass("selected");
                            } else {
                                element.prev().focus().addClass("selected");
                            }

                            if (attrs.listSelect !== "") {
                                element.parent().children(".selected").click();
                            }

                            return false;
                        }

                        if (event.which === 40) {//down arrow
                            element.removeClass("selected").siblings().removeClass("selected");
                            if (element.is(element.parent().children().last())) {
                                element.focus().addClass("selected");
                            } else {
                                element.next().focus().addClass("selected");
                            }

                            if (attrs.listSelect !== "") {
                                element.parent().children(".selected").click();
                            }

                            return false;
                        }
                    });
                    element.bind("click", function(/* event */) {
                        element.removeClass("selected").siblings().removeClass("selected");
                        element.focus().addClass("selected");
                    });
                }
            };
        }
        ]);

    angular
        .module("fleetviewApp")
        .directive(focusListDirective, ["$timeout",
            function($timeout) {
                return {
                    restrict: "A",
                    link: function(scope, element, attrs) {
                        element.bind("click", function(/*event*/) {
                            $timeout(function() {
                                angular.element(attrs.focusList).find(".selected").focus();
                            }, 50);
                        });
                    }
                };
            }
        ]);

    var directiveIdShow = "showonhoverparent";
    var directiveIdHide = "hideonhoverparent";
    angular
        .module("fleetviewApp")
        .directive(directiveIdShow,["$timeout",
        function ($timeout) {
            return {
                restrict: "A",
                link: function (scope, element, attrs) {
                    var overTimeout;
                    element.addClass("parentHoverHide");
                    var elemToBind = element.parent();
                    if (attrs.showonhoverparent !== "") {
                        elemToBind = element.closest(attrs.showonhoverparent);
                    }
                    elemToBind.bind("mouseenter", function () {
                        overTimeout = $timeout(function () {
                            element.removeClass("parentHoverHide");
                            element.addClass("parentHoverShow");
                        }, 150);
                    });
                    elemToBind.bind("mouseleave", function () {
                        $timeout.cancel(overTimeout);
                        element.removeClass("parentHoverShow");
                        element.addClass("parentHoverHide");
                    });
                }
            };
        }
   ]);

    angular
        .module("fleetviewApp")
        .directive(directiveIdHide,
        function () {
            return {
                restrict: "A",
                link: function (scope, element, attrs) {
                    element.addClass("parentHoverShow")

                    var elemToBind = element.parent();

                    if (attrs.hideonhoverparent !== "") {
                        elemToBind = element.closest(attrs.hideonhoverparent);
                    }

                    elemToBind.bind("mouseenter", function () {
                        element.removeClass("parentHoverHide");
                        element.addClass("parentHoverShow");
                    });
                    elemToBind.bind("mouseleave", function () {
                        element.removeClass("parentHoverShow");
                        element.addClass("parentHoverHide");
                    });
                }
            };
        }
    );

})();



// WEBPACK FOOTER //
// ./app/components/list.directive.js